// extracted by mini-css-extract-plugin
export default {"checkBoxWrapper":"checkBox_checkBoxWrapper__rT2Sv","iconComponent":"checkBox_iconComponent__Ydkq8"};